export default __webpack_public_path__ + "static/media/shipping-production.png";